// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Til","colBig":"styles_colBig__1t7eS","colSmall":"styles_colSmall__1IcgA"};